import { QueryClient } from '@tanstack/react-query'

/**
 * Global QueryClient configuration.
 * Centralized here so defaults apply to ALL queries across the app.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes — data is fresh for 5 min
      gcTime: 1000 * 60 * 10, // 10 minutes — cache kept for 10 min
      retry: false, // Don't retry failed queries — server errors (4xx/5xx) won't resolve on retry
      refetchOnWindowFocus: false, // Don't refetch on window focus (clinic app)
      refetchOnReconnect: true, // Refetch when internet reconnects
    },
    mutations: {
      retry: 0, // No retry for mutations by default
    },
  },
})
